import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import _ from 'lodash';

class TableBody extends Component {
    renderCell = (item, column) => {
       if(column.content) return column.content(item);
        return _.get(item, column.path)
};


render() {
    const { data, columns } = this.props;

    return (
            <tbody>
            {data.map(item =>
                    <tr key={item.id} className="gradeX">
                        {columns.map((column, index) => (
                            <td key={index}> {this.renderCell(item, column)}</td>
                        ))
                        }
                    </tr>
            )}

            </tbody>
    );
}
}

export default TableBody


